export default __webpack_public_path__ + "static/media/landing-background.d047bed6.png";